import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68dfbdbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "client-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select a client", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "add"
}, "[+] Create a new client", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "input-group mb-3"
}
const _hoisted_8 = {
  key: 1,
  class: "input-group mb-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Creating.....", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (!_ctx.showCreateForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedClient) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
            }, [
              _hoisted_3,
              _hoisted_4,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientList, (client, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  class: "dropdown-item cursor-pointer",
                  key: index,
                  value: client.clientId
                }, _toDisplayString(client.name), 9, _hoisted_5))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedClient]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showCreateForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!_ctx.creating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "name",
                    placeholder: "Enter the client name",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newClientName) = $event)),
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.createClient && _ctx.createClient(...args)), ["enter"])),
                    onFocusout: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createClient && _ctx.createClient(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.newClientName]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createClient && _ctx.createClient(...args)))
                  }, "Create")
                ]))
              : _createCommentVNode("", true),
            (_ctx.creating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}